export default "__VITE_ASSET__Um9jqmjl__"